import { RequestAction, createRequestActionCreators, createAction as createActionLegacy } from 'helpers/actionsHelpers'
import {
  FutureLayer,
  FutureLayerFields,
  FutureAssumptions,
  FutureLayerCheckResult,
  FutureLayerUID,
  FutureLayerDefinedHints,
  FutureLayerSlug,
} from 'components/features/future/types'
import { FutureNormalizedApiResponse } from 'components/features/future/helpers'
import { SimpleAction } from 'interfaces/action'
import { PastCardValues } from 'components/features/future/FutureLayerPast/types'
import { createAction } from 'helpers/actionHelpers/createAction'


type GetFuturePayload = {}
type GetFutureResponse = FutureNormalizedApiResponse
export const GET_FUTURE = 'GET_FUTURE' as const
type GetFuture = RequestAction<typeof GET_FUTURE, GetFuturePayload, GetFutureResponse>
export const getFutureActionCreator = createRequestActionCreators<typeof GET_FUTURE, GetFuturePayload, GetFutureResponse>(GET_FUTURE)

type PatchFutureLayerPayload =
  & Pick<FutureLayer, 'uid'>
  & Partial<FutureLayerFields>
type PatchFutureLayerResponse =
  & FutureNormalizedApiResponse
export const PATCH_FUTURE_LAYER = 'PATCH_FUTURE_LAYER' as const
type PatchFutureLayer = RequestAction<typeof PATCH_FUTURE_LAYER, PatchFutureLayerPayload, PatchFutureLayerResponse>
export const patchFutureLayerActionCreator = createRequestActionCreators<typeof PATCH_FUTURE_LAYER, PatchFutureLayerPayload, PatchFutureLayerResponse>(PATCH_FUTURE_LAYER)

type PartialCompleteFutureLayerPayload =
  & Pick<FutureLayer, 'uid'>
type PartialCompleteFutureLayerResponse =
  & FutureNormalizedApiResponse
export const PARTIAL_COMPLETE_FUTURE_LAYER = 'PARTIAL_COMPLETE_FUTURE_LAYER' as const
type PartialCompleteFutureLayer = RequestAction<typeof PARTIAL_COMPLETE_FUTURE_LAYER, PartialCompleteFutureLayerPayload, PartialCompleteFutureLayerResponse>
export const partialCompleteFutureLayerActionCreator = createRequestActionCreators<typeof PARTIAL_COMPLETE_FUTURE_LAYER, PartialCompleteFutureLayerPayload, PartialCompleteFutureLayerResponse>(PARTIAL_COMPLETE_FUTURE_LAYER)

type CompleteFutureLayerPayload =
  & Pick<FutureLayer, 'uid'>
  & PastCardValues
type CompleteFutureLayerResponse =
  & FutureNormalizedApiResponse
export const COMPLETE_FUTURE_LAYER = 'COMPLETE_FUTURE_LAYER' as const
export type CompleteFutureLayer = RequestAction<typeof COMPLETE_FUTURE_LAYER, CompleteFutureLayerPayload, CompleteFutureLayerResponse>
export const completeFutureLayerActionCreator = createRequestActionCreators<typeof COMPLETE_FUTURE_LAYER, CompleteFutureLayerPayload, CompleteFutureLayerResponse>(COMPLETE_FUTURE_LAYER)

type PostFutureLayerPayload =
  & FutureLayerFields
type PostFutureLayerResponse =
  & FutureNormalizedApiResponse
export const POST_FUTURE_LAYER = 'POST_FUTURE_LAYER' as const
type PostFutureLayer = RequestAction<typeof POST_FUTURE_LAYER, PostFutureLayerPayload, PostFutureLayerResponse>
export const postFutureLayerActionCreator = createRequestActionCreators<typeof POST_FUTURE_LAYER, PostFutureLayerPayload, PostFutureLayerResponse>(POST_FUTURE_LAYER)

export const RESET_POST_FUTURE_LAYER_ERROR = 'RESET_POST_FUTURE_LAYER_ERROR' as const
export type ResetPostFutureLayerError = SimpleAction<typeof RESET_POST_FUTURE_LAYER_ERROR>
export const resetPostFutureLayerErrorActionCreator = () => createActionLegacy(RESET_POST_FUTURE_LAYER_ERROR)

export type DeleteFutureLayerPayload =
  & Pick<FutureLayer, 'uid'>
type DeleteFutureLayerResponse =
  & FutureNormalizedApiResponse
export const DELETE_FUTURE_LAYER = 'DELETE_FUTURE_LAYER' as const
type DeleteFutureLayer = RequestAction<typeof DELETE_FUTURE_LAYER, DeleteFutureLayerPayload, DeleteFutureLayerResponse>
export const deleteFutureLayerActionCreator = createRequestActionCreators<typeof DELETE_FUTURE_LAYER, DeleteFutureLayerPayload, DeleteFutureLayerResponse>(DELETE_FUTURE_LAYER)


type GetAssumptionsPayload = {}
type GetAssumptionsResponse = FutureAssumptions
export const GET_ASSUMPTIONS = 'GET_ASSUMPTIONS' as const
type GetAssumptions = RequestAction<typeof GET_ASSUMPTIONS, GetAssumptionsPayload, GetAssumptionsResponse>
export const getAssumptionsActionCreator = createRequestActionCreators<typeof GET_ASSUMPTIONS, GetAssumptionsPayload, GetAssumptionsResponse>(GET_ASSUMPTIONS)


type PatchAssumptionsPayload = Partial<FutureAssumptions>
type PatchAssumptionsResponse = FutureNormalizedApiResponse
export const PATCH_ASSUMPTIONS = 'PATCH_ASSUMPTIONS' as const
type PatchAssumptions = RequestAction<typeof PATCH_ASSUMPTIONS, PatchAssumptionsPayload, PatchAssumptionsResponse>
export const patchAssumptionsActionCreator = createRequestActionCreators<typeof PATCH_ASSUMPTIONS, PatchAssumptionsPayload, PatchAssumptionsResponse>(PATCH_ASSUMPTIONS)


type LayerCheckPayload =
  & Partial<FutureLayer>
  & {
    uid?: FutureLayerUID
  }
type LayerCheckResponse = FutureLayerCheckResult
export const LAYER_CHECK = 'LAYER_CHECK' as const
type LayerCheck = RequestAction<typeof LAYER_CHECK, LayerCheckPayload, LayerCheckResponse>
export const layerCheckActionCreator = createRequestActionCreators<typeof LAYER_CHECK, LayerCheckPayload, LayerCheckResponse>(LAYER_CHECK)

export class DropLayerCheckAction extends createAction<'DROP_LAYER_CHECK', void>('DROP_LAYER_CHECK') {}


type GetLayerHintsPayload = {
  slug: FutureLayerSlug
}

export type GetLayerHintsResponse = FutureLayerDefinedHints['hints']
export const GET_LAYER_HINTS = 'GET_LAYER_HINTS' as const
type GetLayerHints = RequestAction<typeof GET_LAYER_HINTS, GetLayerHintsPayload, GetLayerHintsResponse>
export const getLayerHintsActionCreator = createRequestActionCreators<typeof GET_LAYER_HINTS, GetLayerHintsPayload, GetLayerHintsResponse>(GET_LAYER_HINTS)

export class DropGetLayerHintsAction extends createAction<'DROP_GET_LAYER_HINTS', void>('DROP_GET_LAYER_HINTS') {}

type ResetAssumptionsPayload = {}
type ResetAssumptionsResponse = FutureNormalizedApiResponse
export const RESET_ASSUMPTIONS = 'RESET_ASSUMPTIONS' as const
type ResetAssumptions = RequestAction<typeof RESET_ASSUMPTIONS, ResetAssumptionsPayload, ResetAssumptionsResponse>
export const resetAssumptionsActionCreator = createRequestActionCreators<typeof RESET_ASSUMPTIONS, ResetAssumptionsPayload, ResetAssumptionsResponse>(RESET_ASSUMPTIONS)

export type FutureActions =
  | GetFuture
  | PatchFutureLayer
  | PostFutureLayer
  | ResetPostFutureLayerError
  | DeleteFutureLayer
  | GetAssumptions
  | PatchAssumptions
  | LayerCheck
  | GetLayerHints
  | ResetAssumptions
  | PartialCompleteFutureLayer
  | CompleteFutureLayer
  | DropGetLayerHintsAction
  | DropLayerCheckAction
